<template>
  <div class="homeCardContainer">
    <div class="p-grid">
      <home-card
        route="/MapF1"
        image="img/img-f1.png"
        title="Vue générale"
        subtitle="Flux de pratiquants"
        description="Le flux est représenté sous forme d'un réseau simplifié de segments.
          Chaque segment est le fruit d'une agrégation de tracés GPS."
      />
      <home-card
        route="/MapF3"
        image="img/img-f3.png"
        title="Dans une emprise géographique"
        subtitle="Flux des pratiquants"
        description="Le flux est représenté sous forme d'un réseau simplifié de segments à
          l'intérieur d'un périmètre géographique préalablement choisi dans le catalogue."
      />
      <home-card
        route="/MapF4"
        image="img/img-f4.png"
        title="Sur un itinéraire défini"
        subtitle="Flux des pratiquants"
        description="Le flux est représenté sous forme d'un réseau simplifié de segments sur
          le linéaire géographique préalablement choisi dans le catalogue."
      />
      <home-card
        route="/MapF5"
        image="img/img-f5.png"
        title="Zones de départs et zones d’arrivées"
        subtitle=""
        description="Les points de départs ou d'arrivées identifiés depuis les tracés GPS sont
          representés par cluster. Chaque cluster est le fruit de plusieurs points de départs ou
          d'arrivées géographiquement proches."
      />
      <home-card
        route="/MapF6Diff"
        image="img/img-f6.png"
        title="Comparaison temporelle"
        subtitle="Flux des pratiquants"
        description="Le flux est représenté sous forme d'un réseau simplifié de segments.
          Chaque segment exprime la variation du flux calculée entre deux périodes préalablement
          choisies."
      />
      <home-card
        route="/MapF7"
        image="img/img-f7.png"
        title="Répartition des activités"
        subtitle="Flux des pratiquants"
        :description="f7description"
      />
      <home-card
        route="/MapF8"
        image="img/img-f8.png"
        title="Zones de pauses"
        subtitle=""
        description="Les temps de pauses identifiés depuis les tracés GPS sont representés
          par cluster. Chaque cluster est le fruit de plusieurs points géographiquement proches,
          sans déplacement sur une durée minimum de 15 min."
      />
    </div>
  </div>
</template>

<script>
import { f7minPercentage } from '@/utils/settings';

import HomeCard from './HomeCard.vue';

export default {
  name: 'OudoorVision',
  components: { HomeCard },
  data () {
    return {
      f7description: `Le flux est représenté sous forme d'un réseau simplifié de segments.
          Chaque segment exprime la prédominance d'une activité dès lors qu'elle représente
          plus de ${f7minPercentage * 100}% des tracés de celui-ci.`,
    };
  },
};
</script>
